import {
  FetchGisSettingsRequest,
  FetchGisSettingsSuccess,
  FetchGisSettingsFailure,
  UpdateGisSettingsRequest,
  UpdateGisSettingsSuccess,
  UpdateGisSettingsFailure,
} from './gis-settings.actions'
import { GisSettingsService } from './gis-settings.service'
import { ShowSnackbar } from '../../shared/shared.actions'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import * as SmtpSettingsTypes from './gis-settings.types'
import { map, switchMap, tap, catchError } from 'rxjs/operators'
import { Router } from '@angular/router'

@Injectable()
export class GisSettingsEffects {
  constructor(
    private actions: Actions,
    private gisSettingsService: GisSettingsService,
  ) {}

  FetchGisSettings$ = createEffect(() =>
    this.actions.pipe(
      ofType(SmtpSettingsTypes.FETCH_GIS_SETTINGS_REQUEST),
      switchMap((action: FetchGisSettingsRequest) => {
        return this.gisSettingsService.fetchGisSettings().pipe(
          map((result) => {
            return new FetchGisSettingsSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchGisSettingsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UpdateGisSettings$ = createEffect(() =>
    this.actions.pipe(
      ofType(SmtpSettingsTypes.UPDATE_GIS_SETTINGS_REQUEST),
      switchMap((action: UpdateGisSettingsRequest) => {
        return this.gisSettingsService.updateGisSettings(action.payload).pipe(
          switchMap((result) => {
            return [new UpdateGisSettingsSuccess()]
          }),
          catchError((err, caught) => {
            return of(new UpdateGisSettingsFailure({ error: err }))
          }),
        )
      }),
    ),
  )
}
